<template>
  <section id="benefits" class="py-16 md:py-24 bg-base-100">
    <div class="max-w-screen-xl mx-auto px-4">
      <!-- Clean section header -->
      <div class="text-center mb-16">
        <h2 class="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-base-content">
          {{ $t("benefits.heading") }}
        </h2>
        <div class="divider divider-primary w-32 mx-auto mt-6"></div>
        <p class="text-lg text-base-content/80 max-w-2xl mx-auto mt-4">
          {{ $t("benefits.urgencySubtext") }}
        </p>
      </div>

      <!-- Benefits Grid -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div
          v-for="(item, i) in benefits"
          :key="item.key"
          class="card bg-base-200 shadow-lg hover:shadow-xl transition-shadow">
          <div class="card-body">
            <!-- Icon -->
            <div class="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mb-4">
              <component :is="item.icon" class="w-8 h-8 text-primary" />
            </div>

            <!-- Title -->
            <h3 class="text-xl font-bold mb-3 text-base-content">
              {{ $t(`benefits.items.${item.key}.title`) }}
            </h3>

            <!-- Description -->
            <p class="text-base-content/80">
              {{ $t(`benefits.items.${item.key}.amplifier`) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ChatBubbleLeftRightIcon, Cog6ToothIcon, ScaleIcon, WrenchScrewdriverIcon } from "@heroicons/vue/24/outline";

const benefits = [
  { key: "support", icon: ChatBubbleLeftRightIcon },
  { key: "system", icon: Cog6ToothIcon },
  { key: "transparency", icon: ScaleIcon },
  { key: "focus", icon: WrenchScrewdriverIcon },
];
</script>